export const INTEREST_OPTIONS = [
  "Technology",
  "Design",
  "Science",
  "Finance",
  "Startups",
  "Psychology",
  "Philosophy",
  "Writing",
  "Health",
  "Politics",
  "Climate",
  "Arts",
  "Education",
  "Business",
  "History",
];
